import { useQueryClient } from '@tanstack/react-query';
import { useApi, ApiError } from '@/hooks/useApi';
import { useModeAwareMutation } from '@/hooks/useModeAwareQuery';

export interface LogCasePhoneCallRequest {
  caseId: string;
  phoneNumber?: string;
  durationMinutes?: number;
  notes?: string;
  followUpDate?: string;
}

export function useLogCasePhoneCall() {
  const { apiBaseUrl, getHeaders } = useApi();
  const queryClient = useQueryClient();

  return useModeAwareMutation<void, Error, LogCasePhoneCallRequest>(
    async (request) => {
      const { caseId, ...body } = request;
      const headers = await getHeaders();
      const response = await fetch(`${apiBaseUrl}/api/v1/collection-cases/${caseId}/communications/log-call`, {
        method: 'POST',
        headers,
        body: JSON.stringify(body),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new ApiError(
          errorData.message || `HTTP error ${response.status}`,
          response.status,
          errorData
        );
      }
      // 201 Created with null body — no need to parse JSON
    },
    () => {
      // Demo mode: no-op, just return void
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ["collection-cases"] });
        queryClient.invalidateQueries({ queryKey: ["collection-cases-list"] });
        queryClient.invalidateQueries({ queryKey: ["collection-case-detail"] });
        queryClient.invalidateQueries({ queryKey: ["case-recent-activities"] });
        queryClient.invalidateQueries({ queryKey: ["case-audit-logs"] });
      },
    }
  );
}
